import { Box, Typography } from '@mui/material';
import React from 'react';
import { useCommonTranslation } from 'c-translation';
import { makeStyles } from '@mui/styles';
import type { Theme } from '@mui/material/styles';
import type { Filter, Select } from '../../types';
import systemSearchColours from '../../Lib/systemSearchColours';

type FilterProps = { filter: Filter; onSelect: Select };

const useStyles = makeStyles((theme: Theme) => ({
    filterBox: {
        backgroundColor: systemSearchColours(theme).filter,
        color: systemSearchColours(theme).filterText,
        padding: '2px 10px',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        '&:hover': {
            color: systemSearchColours(theme).filterHoverText,
            backgroundColor: systemSearchColours(theme).filterHover,
        },
    },
}));

const SystemSearchFilter = ({ filter: { prefix, description }, onSelect }: FilterProps) => (
    <Box
        id={`system-search-filter-${prefix}`}
        className={useStyles().filterBox}
        onClick={() => onSelect(prefix)}
    >
        <Typography variant="body2">
            <b>{prefix}</b>: {useCommonTranslation(description)}
        </Typography>
    </Box>
);

export default SystemSearchFilter;
